var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getActiveVariationFilters.length > 0 || _vm.getActiveAttributeFilters.length > 0)?_c('div',{staticClass:"listing-filters-clear-all"},[_c('a',{staticClass:"listing-filters-clear-all-link",attrs:{"href":_vm.urlNoFilters}},[_vm._v("\n    "+_vm._s(_vm.t('variation.listing.clear.all'))+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }